import { Component } from '@angular/core';
import { MessageService } from 'primeng/api';


@Component({
  selector: 'app-process-fruzty-page',
  templateUrl: './process-fruzty-page.component.html',
  styleUrls: ['./process-fruzty-page.component.css'],


})
export class ProcessFruztyPageComponent {
  ngOnInit() {
    window.scrollTo(0, 0);
  }
}
